<template>
  <div
    class="gradient-input-wrap"
    @mouseover="closeVisible = true"
    @mouseleave="closeVisible = false"
  >
    <el-input type="number" :max="max" :min="min" v-model="data.value">
      <template #suffix>
        <el-color-picker
          color-format="rgb"
          :show-alpha="true"
          size="mini"
          v-model="data.color"
        ></el-color-picker>
      </template>
    </el-input>
    <el-button
      v-if="closeVisible"
      class="gradient-input__close"
      type="text"
      icon="el-icon-error"
      @click="close"
    ></el-button>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    max: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      closeVisible: false
    };
  },
  methods: {
    close() {
      this.$emit('close', this.data);
    }
  }
};
</script>

<style lang="scss">
.gradient-input-wrap {
  width: 100px;
  position: relative;
  .el-input {
    width: 100px;
  }
  .el-color-picker {
    line-height: 50px;
    border: unset;
    &__trigger {
      width: 20px;
      height: 20px;
      padding: 0;
      border: unset;
    }
  }
  .gradient-input__close {
    position: absolute;
    right: -5px;
    top: -5px;
    padding: 0;
  }
}
</style>
